import React from 'react';

export const PhoneInput = () => {
	return (
		<div>PhoneInput</div>
	);
};
